import {Component, computed, effect, inject, input, output, TemplateRef} from "@angular/core";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {FormControl} from "@angular/forms";
import {AssessablePanelMode} from "@common/components/assessment/utils";
import {AssessmentDataService} from "../services/assessment-data.service";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
	selector: "sim-rating-item",
	templateUrl: "./rating-item.component.html",
	styleUrls: ["./rating-item.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class RatingItemComponent {
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	readonly #dataService = inject(AssessmentDataService);

	// I/O
	public readonly stars = input.required<number>();
	public readonly iconSetId = input<string | null>(null);
	public readonly scoreTemplate = input<TemplateRef<any> | null>(null);
	public readonly hideScore = input<boolean>(false);
	public readonly inEditMode = input<boolean>(false);
	public readonly mode = input<AssessablePanelMode>(AssessablePanelMode.View);
	public readonly answer = input<number | null>(null);
	public readonly starScores = input<number[]>([]);

	public readonly onAddStar = output<void>();
	public readonly onRemoveStar = output<void>();
	public readonly onStarClick = output<number>();

	protected readonly iconSets = toSignal(this.#dataService.iconSets$, {initialValue: []});
	protected readonly isEditing = computed(() => this.mode() === AssessablePanelMode.Edit && this.inEditMode());
	protected readonly starsArray = computed(() =>
		Array.from({length: this.stars()})
			.map((_, i) => i)
			.toReversed(),
	);
	protected readonly iconSet = computed(() => this.iconSets().find((iconSet) => iconSet.id === this.iconSetId()) ?? null);

	protected readonly pointControl = new FormControl<number | null>(null);

	constructor() {
		effect(() => {
			const answer = this.answer();
			const starScores = this.starScores();
			const newValue = answer ? starScores[answer] : null;
			this.pointControl.setValue(newValue);
		});
	}

	public getIconColor(index: number): string | null {
		const iconSet = this.iconSet();
		const answer = this.answer();

		const iconConfig = iconSet?.icons[index];
		if (!iconConfig) {
			return null;
		}
		const color = answer === index ? iconConfig.activeColor : iconConfig.inactiveColor;
		if (!color) {
			return null;
		}
		return `${color} !important`;
	}
}
